import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FieldErrors } from 'react-hook-form/dist/types/errors';
import { useTranslation } from 'react-i18next';

import Input from '@components/common/Input';
import MaskedInput from '@components/common/MaskedInput';

import useStyles from './styles';

export interface IPayerCardAddressFormProps {
  onSuccess?: (result: unknown) => void;
  onError?: (error?: unknown) => void;
  onValidationError?: (errors: FieldErrors) => void;
}

const PayerCardAddressForm: FC<IPayerCardAddressFormProps> = () => {
  const { control, formState } = useFormContext();
  const css = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Grid className={css.formRow}>
        <Controller
          name="payerAddress"
          defaultValue=""
          rules={{ required: true }}
          control={control}
          render={({ field: { ref, ...field }, fieldState }) => (
            <Input
              {...field}
              inputRef={ref}
              data-testid="payer-address"
              label={t('checkoutScreen.payment.payerAddress.address')}
              fullWidth
              autoComplete="off"
              disabled={formState.isSubmitting}
              error={fieldState.invalid}
            />
          )}
        />
      </Grid>
      <Grid className={css.formRow}>
        <Controller
          control={control}
          defaultValue=""
          name="payerCity"
          rules={{ required: true }}
          render={({ field: { ref, ...field }, fieldState }) => (
            <Input
              {...field}
              inputRef={ref}
              data-testid="payer-city"
              label={t('checkoutScreen.payment.payerAddress.city')}
              fullWidth
              autoComplete="off"
              disabled={formState.isSubmitting}
              error={fieldState.invalid}
            />
          )}
        />
      </Grid>
      <Grid className={css.formRow}>
        <Controller
          name="payerState"
          defaultValue=""
          control={control}
          rules={{ required: true }}
          render={({ field: { ref, ...field }, fieldState }) => (
            <Input
              {...field}
              inputRef={ref}
              data-testid="payer-state"
              label={t('checkoutScreen.payment.payerAddress.state')}
              fullWidth
              autoComplete="off"
              disabled={formState.isSubmitting}
              error={fieldState.invalid}
            />
          )}
        />
      </Grid>
      <Grid className={css.formRow}>
        <Controller
          name="payerCountry"
          control={control}
          defaultValue=""
          rules={{ required: true }}
          render={({ field: { ref, ...field }, fieldState }) => (
            <Input
              {...field}
              inputRef={ref}
              data-testid="payer-country"
              label={t('checkoutScreen.payment.payerAddress.country')}
              fullWidth
              autoComplete="off"
              disabled={formState.isSubmitting}
              error={fieldState.invalid}
            />
          )}
        />
        <Controller
          name="payerZipCode"
          control={control}
          defaultValue=""
          rules={{ required: true }}
          render={({ field: { ref, ...field }, fieldState }) => (
            <MaskedInput
              {...field}
              inputRef={ref}
              label={t('checkoutScreen.payment.payerAddress.zipCode')}
              autoComplete="off"
              fullWidth
              inputProps={{
                'data-testid': 'payer-zipCode',
                inputMode: 'numeric',
                mask: '99999',
              }}
              disabled={formState.isSubmitting}
              error={fieldState.invalid}
            />
          )}
        />
      </Grid>
    </>
  );
};

export default observer(PayerCardAddressForm);
